<template>
  <div class="space-y-4">
    <div>
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        Día de la Semana *
      </label>
      <select 
        :value="modelValue.day" 
        required
        class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
        @input="updateField('day', $event)"
      >
        <option value="">
          Selecciona un día...
        </option>
        <option value="monday">
          Lunes
        </option>
        <option value="tuesday">
          Martes
        </option>
        <option value="wednesday">
          Miércoles
        </option>
        <option value="thursday">
          Jueves
        </option>
        <option value="friday">
          Viernes
        </option>
        <option value="saturday">
          Sábado
        </option>
        <option value="sunday">
          Domingo
        </option>
      </select>
    </div>

    <div>
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        Costo de Envío *
      </label>
      <div class="relative">
        <span class="absolute left-3 top-2 text-gray-500 dark:text-gray-400">$</span>
        <input 
          :value="modelValue.fee" 
          type="number"
          min="0" 
          step="0.01" 
          required 
          class="w-full pl-8 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
          placeholder="0.00"
          @input="updateField('fee', $event)" 
        >
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  modelValue: Record<string, any>
}

const props = defineProps<Props>()

const emit = defineEmits<{
  'update:modelValue': [value: Record<string, any>]
}>()

const updateField = (field: string, event: Event) => {
  const target = event.target as HTMLInputElement | HTMLSelectElement
  const value = target.type === 'number' ? (parseFloat(target.value) || 0) : target.value
  emit('update:modelValue', {
    ...props.modelValue,
    [field]: value
  })
}
</script>
